import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnInit, Signal } from '@angular/core';
import { ButtonModule, SelectModule, InputModule } from '@sag-ui';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CreditReviewForm, CreditReviewFormGroup } from '../../../models/cod-review.model';
import { CodReviewOperations } from '../../../operations/cod-review.operations';
import { AttachmentsInputComponent } from '../../../../shared/components/attachments-input/attachments-input.component';
import { CodReviewState } from '../../../state/cod-review.state';
import { select, Store } from '@ngxs/store';
import { SubmitCreditReview } from '../../../state/cod-review.action';
import { CodReviewSuccessComponent } from '../review-success/review-success.component';
import { NgxsFormDirective } from '@ngxs/form-plugin';

@Component({
    selector: 'app-cod-credit-review-step',
    templateUrl: './credit-review.component.html',
    imports: [
        CommonModule,
        SelectModule,
        FormsModule,
        ReactiveFormsModule,
        InputModule,
        ButtonModule,
        AttachmentsInputComponent,
        CodReviewSuccessComponent,
        NgxsFormDirective
    ],
    standalone: true
})
export class CodCreditReviewStepComponent implements OnInit, OnChanges {
    @Input() disabled: boolean;

    protected submitting: Signal<boolean> = select(CodReviewState.submittingCreditReview);
    protected submittingSuccess: Signal<boolean> = select(CodReviewState.submittingCreditReviewSuccess);

    public formGroup: FormGroup<CreditReviewFormGroup>;

    constructor(private store: Store) {}

    public ngOnInit(): void {
        this.formGroup = CodReviewOperations.initializeCreditReviewForm();

        if (this.disabled) {
            this.formGroup.disable();
        }
    }

    public ngOnChanges(): void {
        if (this.disabled) {
            this.formGroup && this.formGroup.disable();
        } else {
            this.formGroup && this.formGroup.enable();
        }
    }

    public submit(): void {
        if (this.formGroup.invalid) {
            return;
        }

        this.store.dispatch(new SubmitCreditReview(this.formGroup.value as CreditReviewForm));
        this.formGroup.disable();
    }

    public get invalid(): boolean {
        return this.formGroup.invalid;
    }
}
